import { FormLabel, TextField ,Box, Button, FormControlLabel, Checkbox } from '@mui/material';
import React, { useState } from 'react'
import axios from 'axios';
import {useNavigate} from 'react-router-dom';

function AddBook() {
  const navigate = useNavigate();
  const [name , setName] = useState('');
  const [author , setAuthor] = useState('');
  const [description , setDescription] = useState('');
  const [image , setImage] = useState('');
  const [price , setPrice] = useState('');
  const [checked, setChecked] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    sendRequest().then(() => navigate('/books'))
    // console.log({
    //   "name":name,
    //   "author": author,
    //   "description": description,
    //   "image": image,
    //   "price": price,
    //   "available": checked
    // })
  }

  //now create function to send data in the database
  const sendRequest = async () => {
    await axios.post("https://bookstore-hyob.onrender.com/books", {
      name: String(name),
      author: String(author),
      description: String(description),
      price: Number(price),
      image: String(image),
      available: Boolean(checked)
    }).then(res =>res.data);
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
       <Box display="flex" flexDirection="column" justifyContent={"centre"} maxWidth={700} alignContent={'center'} alignSelf='center' marginLeft='auto' marginRight='auto' marginTop={10}>
       <FormLabel>Name</FormLabel>
        <TextField onChange={(e) => setName(e.target.value)} margin='normal' fullWidth variant='outlined' name='name' />
        <FormLabel>Author</FormLabel>
        <TextField onChange={(e) => setAuthor(e.target.value)} margin='normal' fullWidth variant='outlined' name='author' />
        <FormLabel>Description</FormLabel>
        <TextField onChange={(e) => setDescription(e.target.value)} margin='normal' fullWidth variant='outlined' name='description' />
        <FormLabel>Image</FormLabel>
        <TextField onChange={(e) => setImage(e.target.value)} margin='normal' fullWidth variant='outlined' name='image' /> 
        <FormLabel>Price</FormLabel>
        <TextField onChange={(e) => setPrice(e.target.value)} type='number' margin='normal' fullWidth variant='outlined' name='price' />
        <FormControlLabel control={<Checkbox checked={checked} onChange={() => setChecked(!checked)} />} label="Available" />
        <Button variant='contained' sx={{mt: "20px"}} type='submit'>Add Book</Button>
       </Box>
      </form>
    </div>
  )
}

export default AddBook;